import React from 'react';

const Settings: React.FunctionComponent<React.PropsWithChildren> = () => {
    return <div>Settings</div>;
};

export default Settings;
